module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921034149_T.f3f72cb7.jpg";